// Command Mappings Configuration - 指令映射配置
// 集中管理所有命令的中文和英文映射，提高扩展性和可维护性

export const COMMAND_MAPPINGS = {
  // 英文命令 -> 中文显示
  englishToChinese: {
    'help': '帮助',
    'status': '状态',
    'explore': '机缘',
    'learn': '学习',
    'use': '使用',
    'join': '宗门',
    'bag': '背包',
    'travel': '地图',
    'reset': '重置',
    'cultivate': '修炼',
    'refine_pill': '炼丹',
    'refine_treasure': '炼器',
    'info': '信息',
    'discoveries': '发现'
  },

  // 中文命令 -> 英文命令
  chineseToEnglish: {
    '帮助': 'help',
    '状态': 'status',
    '机缘': 'explore',
    '修炼': 'cultivate',
    '学习': 'learn',
    '使用': 'use',
    '宗门': 'join',
    '背包': 'bag',
    '地图': 'travel',
    '重置': 'reset',
    '炼丹': 'refine_pill',
    '炼器': 'refine_treasure',
    '信息': 'info',
    '发现': 'discoveries'
  },

  // 命令描述映射
  descriptions: {
    'help': '显示可用指令列表',
    'status': '查看角色状态信息',
    'explore': '机缘当前区域',
    'learn': '学习技能',
    'use': '使用背包中的物品',
    'join': '加入修仙门派',
    'bag': '查看背包物品',
    'travel': '前往其他地点',
    'reset': '重置游戏进度',
    'cultivate': '修炼提升修为',
    'refine_pill': '在洞府中炼制丹药',
    'refine_treasure': '在洞府中炼制法宝',
    'info': '查看物品信息',
    'discoveries': '查看机缘发现'
  },

  // 命令别名
  aliases: {
    'exp': 'explore',
    '修炼': 'cultivate',
    '炼药': 'refine_pill',
    '锻宝': 'refine_treasure'
  }
};

// 辅助函数：获取中文命令名
export function getChineseCommand(command) {
  return COMMAND_MAPPINGS.englishToChinese[command] || command;
}

// 辅助函数：获取英文命令名
export function getEnglishCommand(command) {
  // 先检查别名
  if (COMMAND_MAPPINGS.aliases[command]) {
    return COMMAND_MAPPINGS.aliases[command];
  }
  // 再检查中文映射
  return COMMAND_MAPPINGS.chineseToEnglish[command] || command;
}

// 辅助函数：获取命令描述
export function getCommandDescription(command) {
  return COMMAND_MAPPINGS.descriptions[command] || '未知指令';
}

// 辅助函数：获取所有可用命令（英文）
export function getAllCommands() {
  return Object.keys(COMMAND_MAPPINGS.englishToChinese);
}

// 辅助函数：获取所有中文命令名
export function getAllChineseCommands() {
  return Object.values(COMMAND_MAPPINGS.englishToChinese);
}

// 辅助函数：检查是否为有效命令
export function isValidCommand(command) {
  return command in COMMAND_MAPPINGS.englishToChinese ||
         command in COMMAND_MAPPINGS.chineseToEnglish ||
         command in COMMAND_MAPPINGS.aliases;
}
